import type { FC } from 'react';
import React, { useCallback, useMemo } from 'react';
import type { GetTransactionsWithReceiptDto } from '@pflegenavi/shared/api';
import { fmAppMainPages } from '@pflegenavi/frontend/routing';
import { useNavigate } from 'react-router-dom';
import { LatestFMPaymentView } from './LatestFMPaymentView';
import type { PaymentViewPendingCharge } from './LatestFMPaymentView';

// ----------------------------------------------------------------------

interface LatestFMPaymentsProps {
  isLoading: boolean;
  data: GetTransactionsWithReceiptDto[];
  allPendingCharges?: PaymentViewPendingCharge[];
  nursingHomePhone?: string;
  nursingHomeName?: string;
}

export const LatestFMPayments: FC<LatestFMPaymentsProps> = ({
  isLoading,
  data,
  allPendingCharges = [],
  nursingHomePhone,
  nursingHomeName,
}) => {
  const navigate = useNavigate();

  const handleViewAll = useCallback(() => {
    navigate(fmAppMainPages.PAYMENTS);
  }, [navigate]);

  // Map GetTransactionsWithReceiptDto to the simpler PaymentData interface
  const mappedData = useMemo(
    () =>
      data.map((transaction) => ({
        id: transaction.id,
        amountInCent: transaction.amountInCent,
        date: transaction.date,
        sourceType: transaction.sourceType,
        initiatedBy: transaction.initiatedBy,
        disputed: transaction.disputed,
        cancelled: transaction.cancelled,
        creatorName: transaction.creatorName,
      })),
    [data]
  );

  return (
    <LatestFMPaymentView
      isLoading={isLoading}
      data={mappedData}
      allPendingCharges={allPendingCharges}
      nursingHomePhone={nursingHomePhone}
      nursingHomeName={nursingHomeName}
      onViewAll={handleViewAll}
      maxRows={5}
    />
  );
};
